import React, { useState } from "react";
import { airports } from "airports-json";
import "./FlightSearch.css";
import api from "../../Api.js";
import { useNavigate } from "react-router-dom";
import FullscreenSpinner from "../../Components/Helping Component/Fullscreeenspinner.jsx";

export default function FlightSearch({ initialData }) {

  const [showTraveler, setShowTraveler] = useState(false);
  const [fromList, setFromList] = useState([]);
  const [toList, setToList] = useState([]);
  const [tripType, setTripType] = useState(initialData?.tripType || "oneway");
  const [from, setFrom] = useState(initialData?.from || "");
  const [to, setTo] = useState(initialData?.to || "");
  const [fromCode, setFromCode] = useState(initialData?.fromCode || "");
  const [toCode, setToCode] = useState(initialData?.toCode || "");
  const [departureDate, setDepartureDate] = useState(initialData?.departureDate || "");
  const [returnDate, setReturnDate] = useState(initialData?.returnDate || "");
  const [adults, setAdults] = useState(initialData?.adults || 1);
  const [children, setChildren] = useState(initialData?.children || 0);
  const [infants, setInfants] = useState(initialData?.infants || 0);
  const [travelClass, setTravelClass] = useState(initialData?.travelClass || "Economy");



  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const today = new Date().toISOString().split("T")[0];

  const [segments, setSegments] = useState([
    {
      from: "",
      fromCode: "",
      to: "",
      toCode: "",
      date: ""
    }
  ]);


  const searchAirport = (value, setter) => {
    if (!value) return setter([]);
    const result = airports
      .filter(
        a =>
          a.iata_code &&
          (a.municipality?.toLowerCase().includes(value.toLowerCase()) ||
            a.iata_code.toLowerCase().includes(value.toLowerCase()))
      )
      .slice(0, 6);
    setter(result);
  };

  const searchAirportForSegment = (value, index, type) => {
  if (!value) {
    const updated = [...segments];
    updated[index][`${type}List`] = [];
    setSegments(updated);
    return;
  }

  const result = airports
    .filter(
      a =>
        a.iata_code &&
        (a.municipality?.toLowerCase().includes(value.toLowerCase()) ||
          a.iata_code.toLowerCase().includes(value.toLowerCase()))
    )
    .slice(0, 6);

  const updated = [...segments];
  updated[index][`${type}List`] = result;
  setSegments(updated);
};


  const handleSearchFlights = async () => {
    try {
      setLoading(true);

      /* ================= MULTI-CITY ================= */
if (tripType === "multicity") {
  for (let seg of segments) {
    if (!seg.fromCode || !seg.toCode || !seg.date) {
      alert("Please fill all multicity fields");
      setLoading(false);
      return;
    }
  }

  const payload = {
    adults,
    children,
    infants,
    Segments: segments.map(seg => ({
      Origin: seg.fromCode,
      Destination: seg.toCode,
      FlightCabinClass: 2,
      PreferredDepartureTime: seg.date,
      PreferredArrivalTime: seg.date
    }))
  };

  const response = await api.post("/flights/multicity-search", payload);

  navigate("/flight-search-result", {
    state: {
      results: response.data, // ✅ FIXED
      searchData: {
        tripType,
        segments,
        adults,
        children,
        infants,
        travelClass
      }
    }
  });

  return;
}


      /* ================= ONE-WAY / ROUND-TRIP ================= */
      if (!fromCode || !toCode || !departureDate) {
        alert("Please fill all required fields");
        setLoading(false);
        return;
      }

      const payload = {
        adults,
        children,
        infants,
        isoneway: tripType === "oneway" ? "Yes" : "No",
        From_IATACODE: fromCode,
        To_IATACODE: toCode,
        departure_date: departureDate,
        ...(tripType === "roundtrip" && {
          return_date: returnDate
        })
      };

      const response = await api.post("/flights/search", payload);

      

      if (response.data?.status === true) {
        navigate("/flight-search-result", {
          state: {
            results: response.data,
            searchData: {
              tripType,
              from,
              to,
              fromCode,
              toCode,
              departureDate,
              returnDate,
              adults,
              children,
              infants,
              travelClass
            }
          }
        });
      }
    } catch (err) {
      console.error(err);
      alert("Flight search failed");
    } finally {
      setLoading(false);
    }
  };


  const addCity = () => {
    setSegments([
      ...segments,
      {
        from: "",
        fromCode: "",
        to: "",
        toCode: "",
        date: "",
        fromList: [],
        toList: []
      }
    ]);
  };


  const removeCity = index => {
    if (segments.length === 1) return;
    setSegments(segments.filter((_, i) => i !== index));
  };


  return (
    <div className="flight-search-wrapper">
      {loading && initialData && <FullscreenSpinner />}
      {/* TOP BAR */}
      <div className="flight-search-bar">

        {/* Trip Type */}
        <div className="trip-types">
          {["oneway", "roundtrip", "multicity"].map(t => (
            <label key={t}>
              <input
                type="radio"
                checked={tripType === t}
                onChange={() => setTripType(t)}
              />
              {t.replace(/^\w/, c => c.toUpperCase())}
            </label>
          ))}
        </div>

        {/* SEARCH GRID */}

        {
          tripType === "oneway" &&
          <div className="search-grid">

            {/* FROM */}
            <div className="field autocomplete">
              <label>Flying from</label>
              <input
                value={from}
                placeholder="Kolkata, India"
                onChange={e => {
                  setFrom(e.target.value);
                  searchAirport(e.target.value, setFromList);
                }}
              />
              {fromList.length > 0 && (
                <ul className="suggestions">
                  {fromList.map(a => (
                    <li
                      key={a.iata_code}
                      onClick={() => {
                        setFrom(`${a.municipality}(${a.iata_code})`);
                        setFromCode(a.iata_code);
                        setFromList([]);
                      }}
                    >
                      {a.municipality},{a.name} ({a.iata_code})
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* TO */}
            <div className="field autocomplete">
              <label>Flying to</label>
              <input
                value={to}
                placeholder="Kolkata, India"
                onChange={e => {
                  setTo(e.target.value);
                  searchAirport(e.target.value, setToList);
                }}
              />
              {toList.length > 0 && (
                <ul className="suggestions">
                  {toList.map(a => (
                    <li
                      key={a.iata_code}
                      onClick={() => {
                        setTo(`${a.municipality}(${a.iata_code})`);
                        setToCode(a.iata_code);
                        setToList([]);
                      }}
                    >
                      {a.municipality},{a.name} ({a.iata_code})
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* DEPART */}
            <div className="field">
              <label>Depart</label>
              <input
                type="date"
                value={departureDate}
                min={new Date().toISOString().split("T")[0]}
                onChange={e => setDepartureDate(e.target.value)}
              />

            </div>

            {/* RETURN */}
            <div className="field">
              <label>Return</label>
              <input
                type="date"
                disabled={tripType === "oneway"}
                value={returnDate}
                min={new Date().toISOString().split("T")[0]}
                onChange={e => setReturnDate(e.target.value)}
              />
            </div>

            {/* TRAVELERS */}
            <div className="field traveler-field" onClick={() => setShowTraveler(!showTraveler)}>
              <label>Travelers</label>
              <input readOnly value={`${adults + children + infants} Passenger(s)`} />
            </div>

            {/* SEARCH BUTTON */}
            <button className="search-btn" onClick={handleSearchFlights}>
              {loading ? "Searching..." : "Search"}
            </button>
          </div>
        }

        {tripType === "multicity" && (
          <div className="multicity-wrapper">

            {segments.map((seg, index) => (
              <div key={index} className="multicity-row">

                {/* FROM */}
                <div className="field autocomplete">
                  <input
                    placeholder="From"
                    value={seg.from}
                    onChange={e => {
                      const updated = [...segments];
                      updated[index].from = e.target.value;
                      setSegments(updated);
                      searchAirportForSegment(e.target.value, index, "from");
                    }}
                  />

                  {seg.fromList?.length > 0 && (
                    <ul className="suggestions">
                      {seg.fromList.map(a => (
                        <li
                          key={a.iata_code}
                          onClick={() => {
                            const updated = [...segments];
                            updated[index].from = `${a.municipality} (${a.iata_code})`;
                            updated[index].fromCode = a.iata_code;
                            updated[index].fromList = [];
                            setSegments(updated);
                          }}
                        >
                          {a.municipality}, {a.name} ({a.iata_code})
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                {/* TO */}
                <div className="field autocomplete">
                  <input
                    placeholder="To"
                    value={seg.to}
                    onChange={e => {
                      const updated = [...segments];
                      updated[index].to = e.target.value;
                      setSegments(updated);
                      searchAirportForSegment(e.target.value, index, "to");
                    }}
                  />

                  {seg.toList?.length > 0 && (
                    <ul className="suggestions">
                      {seg.toList.map(a => (
                        <li
                          key={a.iata_code}
                          onClick={() => {
                            const updated = [...segments];
                            updated[index].to = `${a.municipality} (${a.iata_code})`;
                            updated[index].toCode = a.iata_code;
                            updated[index].toList = [];
                            setSegments(updated);
                          }}
                        >
                          {a.municipality}, {a.name} ({a.iata_code})
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                {/* DATE */}
                <input
                  type="date"
                  min={today}
                  value={seg.date}
                  onChange={e => {
                    const updated = [...segments];
                    updated[index].date = e.target.value;
                    setSegments(updated);
                  }}
                />

                {/* REMOVE */}
                {segments.length > 1 && (
                  <button className="remove-btn" onClick={() => removeCity(index)}>
                    ✕
                  </button>
                )}
              </div>
            ))}


            {/* ADD CITY */}
            <button className="add-city-btn" onClick={addCity}>
              + Add another city
            </button>

            {/* ========= TRAVELERS (MULTICITY) ========= */}
            <div
              className="field traveler-field multicity-traveler"
              onClick={() => setShowTraveler(!showTraveler)}
            >
              <label>Travelers</label>
              <input
                readOnly
                value={`${adults + children + infants} Passenger(s)`}
              />
            </div>

            {/* ========= SEARCH BUTTON (MULTICITY) ========= */}
            <button className="search-btn multicity-search" onClick={handleSearchFlights}>
              {loading ? "Searching..." : "Search Flights"}
            </button>
          </div>
        )}


      </div>

      {/* TRAVELER DROPDOWN */}
      {showTraveler && (
        <div className="traveler-dropdown">

          <div className="row1">
            <span style={{ width: "100px" }}>Adults</span>
            <button onClick={() => setAdults(Math.max(1, adults - 1))}>-</button>
            <span>{adults}</span>
            <button onClick={() => setAdults(adults + 1)}>+</button>
          </div>

          <div className="row1">
            <span style={{ width: "100px" }}>Children</span>
            <button onClick={() => setChildren(Math.max(0, children - 1))}>-</button>
            <span>{children}</span>
            <button onClick={() => setChildren(children + 1)}>+</button>
          </div>

          <div className="row1">
            <span style={{ width: "100px" }}>Infants</span>
            <button onClick={() => setInfants(Math.max(0, infants - 1))}>-</button>
            <span>{infants}</span>
            <button onClick={() => setInfants(infants + 1)}>+</button>
          </div>

          <h4>Travel Class</h4>
          {["Any", "Economy", "Premium Economy", "Business", "First"].map(c => (
            <label key={c}>
              <input
                type="radio"
                checked={travelClass === c}
                onChange={() => setTravelClass(c)}
              />
              {c}
            </label>
          ))}
          <div className="row1">

            <button className="done-btn" onClick={() => setShowTraveler(false)}>
              Done
            </button>
          </div>

        </div>
      )}
    </div>
  );
}
